const botaoStyles = {
    borderRadius: '2px',
    background: '#263238',
    padding: '8px 22px',
    color: '#fff',
    '&:hover': {
        background: '#263238',
    },
};

export default botaoStyles;